import React from 'react'
import Subtotal from './Subtotal';
import AddedProduct from './AddedProduct';
import "./css/Cart.css";
import { useStateValue } from './StateProvider';

function Cart() {
  const [{basket, user}, dispatch]= useStateValue();

  return (
    <div class="cart">
      <div className="cart-items">
        <div>
        <h2 className="title">{user ? user?.displayName: "Your"} Cart</h2>

        {basket.length === 0 ? (
              <h4 style={{textAlign: "center", fontFamily: "sans-serif"}}>You havent add anything to cart, Let fix that <a href="/home" style={{textDecoration: "none", color: "black"}}>Click Here</a></h4>
            ) : (
              <>
        {basket?.map((item) => (
          <AddedProduct
          id={item?.id}
          title={item?.title}
          image={item?.image}
          price={item?.price}
          />
        ))}
        </>
        )}

        </div>
      </div>
      <div class="subtotal">
        <Subtotal />
      </div>
    </div>
  )
}

export default Cart